// extracted by mini-css-extract-plugin
module.exports = {"regModalWrapper":"styles_regModalWrapper__hqNAg","bg":"styles_bg__h2usl","bgMobile":"styles_bgMobile__dT_ls"};